// Display helpers shared by the existing-draft notice and the recovery prompt.

// "8:45 AM" stays as typed; "08:45" (time-input format) becomes "8:45 AM".
export function formatClock(value) {
  if (!value) return null;
  const match = /^(\d{1,2}):(\d{2})$/.exec(String(value).trim());
  if (!match) return String(value);
  const hours24 = Number(match[1]);
  const period = hours24 >= 12 ? 'PM' : 'AM';
  return `${hours24 % 12 || 12}:${match[2]} ${period}`;
}

// Date-only value ("2026-09-24"): show the calendar date as stored.
export function formatDateOnly(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(value || ''));
  return match ? `${match[2]}/${match[3]}/${match[1]}` : '';
}

// Save timestamp: shown in the user's local time.
export function formatSavedAt(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  const hours24 = d.getHours();
  const time = `${hours24 % 12 || 12}:${String(d.getMinutes()).padStart(2, '0')} ${hours24 >= 12 ? 'PM' : 'AM'}`;
  const today = new Date();
  const sameDay = d.getFullYear() === today.getFullYear() && d.getMonth() === today.getMonth() && d.getDate() === today.getDate();
  return sameDay ? `today at ${time}` : `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()} at ${time}`;
}
